import { getSeatingMapData } from "@services/eventAPI";
import { drawGraphBackground } from "@utils/seatingUtils/canvasBackground";
import {
  convertHoldsBack,
  convertTiersBack,
} from "@utils/seatingUtils/convertObjects";
import { createMatricesFromItems } from "@utils/seatingUtils/createMatrices";
import { sortItemsBySide } from "@utils/seatingUtils/sortTableBySide";
import React, { useEffect, useRef, useState } from "react";
import styles from "./seating.module.css";
import { drawObjects } from "@utils/seatingUtils/drawingObjects/mainDrawing";
import { rotateCoords } from "@utils/seatingUtils/rotateCoordinates";
import { calculateTableDimensions } from "@utils/seatingUtils/drawingObjects/drawTable";
import { handleSelection } from "@utils/seatingUtils/handleSelectSeats";
import SeatingCart from "./cart/cart";
import { BsExclamationCircle } from "react-icons/bs";
import MessageDisplay from "@utils/messagesDisplay/messageDisplay";

export default function SeatingComponent({
  sizeScreen,
  seatingMapID,
  handleOpenCloseSeating,
  seatingTickets,
  utm_source,
  eventID,
  app,
  user,
  deviceWidth,
  deviceHeight,
  whish = false,
  redirectUrl,
  userIdentifier,
  event = null,
  handleOpenPolicy
}) {
  const [isMobile, setIsMobile] = useState(false);
  // console.log(app, user, utm_source);
  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });

    useEffect(() => {
      // only execute all the code below in client side
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }

      // Add event listener
      window.addEventListener("resize", handleResize);

      // Call handler right away so state gets updated with initial window size
      handleResize();

      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }
  const size = useWindowSize();
  useEffect(() => {
    const canvas = document.querySelector("canvas");

    const preventZoom = (event) => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    };

    if (canvas) {
      canvas.addEventListener("touchstart", preventZoom, { passive: false });
      canvas.addEventListener("touchmove", preventZoom, { passive: false });
    }

    return () => {
      if (canvas) {
        canvas.removeEventListener("touchstart", preventZoom);
        canvas.removeEventListener("touchmove", preventZoom);
      }
    };
  }, []);

  // useEffect(() => {
  //   const mediaQuery = window.matchMedia("(pointer: coarse)");
  //   setIsMobile(mediaQuery.matches);

  //   const handleMediaQueryChange = (event) => {
  //     setIsMobile(event.matches);
  //   };

  //   mediaQuery.addListener(handleMediaQueryChange);

  //   return () => {
  //     mediaQuery.removeListener(handleMediaQueryChange);
  //   };
  // }, []);
  const [showLegend, setShowLegend] = useState(false);

  // retrieve and prepare data
  const [objects, setObjects] = useState([]);
  const [TiersTypes, setTiersTypes] = useState([]);
  const [HoldTypes, setHoldTypes] = useState([]);
  const [saveLoad, setSaveLoad] = useState(false);
  const [orgID, setOrgID] = useState("");
  const adjustViewToFitObjects = (objects) => {
    if (objects.length === 0)
      return {
        bounds: {
          minX: 0,
          maxX: 0,
          minY: 0,
          maxY: 0,
        },
        offSet: { x: 0, y: 0 },
        newZoom: 1,
      };

    // setCurrentCanvasOffset(canvasOffset);
    // setCurrentZoom(zoom);
    let dimensions = { startX: [], endX: [], startY: [], endY: [] };

    objects.forEach((obj) => {
      let startX, endX, startY, endY;
      let skip = obj.isHidden ?? false;
      switch (obj.type) {
        case "rectangle":
        case "generalArea":
        case "text":
          startX = obj.x;
          endX = obj.x + obj.width;
          startY = obj.y;
          endY = obj.y + obj.height;
          break;
        case "matrix":
          if(!obj.matrix) return;
          const spacing = obj.itemRadius * 2.2;
          startX = obj.x - 30;
          endX =
            obj.x +
            spacing * (obj.matrix[0].length - 1) +
            obj.itemRadius * 2 +
            20;
          startY = obj.y - 30;
          endY =
            obj.y + spacing * (obj.matrix.length - 1) + obj.itemRadius * 2 + 20;
          break;
        case "table":
          const { adjustedWidth, adjustedHeight } = calculateTableDimensions(
            obj,
            circleRadius,
            edgePadding
          );
          startX = obj.x - circleRadius;
          endX = startX + adjustedWidth + circleRadius * 4 + edgePadding * 2;
          startY = obj.y - circleRadius;
          endY = startY + adjustedHeight + circleRadius * 4 + edgePadding * 2;
          break;
      }
      if(obj.type === "matrix" && skip){console.log("");
      }
      else {
      dimensions.startX.push(startX);
      dimensions.endX.push(endX);
      dimensions.startY.push(startY);
      dimensions.endY.push(endY);
      }
    });

    const minX = Math.min(...dimensions.startX);
    const maxX = Math.max(...dimensions.endX);
    const minY = Math.min(...dimensions.startY);
    const maxY = Math.max(...dimensions.endY);

    const objectsWidth = maxX - minX;
    const objectsHeight = maxY - minY;

    const zoomX = 800 / objectsWidth;
    const zoomY = 600 / objectsHeight;
    const newZoom = Math.min(zoomX, zoomY, 10); // Cap zoom to prevent excessive zoom-in

    const newOffsetX = minX;
    const newOffsetY = Math.abs(minY);

    return {
      bounds: {
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY,
      },
      offSet: { x: newOffsetX, y: newOffsetY },
      newZoom,
    };
  };
  function getMinMaxCoordinates(data) {
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;

    data.forEach((item) => {
      if (item.x < minX) minX = item.x;
      if (item.y < minY) minY = item.y;
      if (item.x + item.baseWidth > maxX) maxX = item.x + item.baseWidth;
      if (item.y + item.baseHeight > maxY) maxY = item.y + item.baseHeight;
    });

    return { minX, minY, maxX, maxY };
  }

  // console.log(sizeScreen);

  const adjustZoomOffset = (updated) => {
    const { bounds } = adjustViewToFitObjects(updated);
    let widthScreen = 1366;
    let heightScreen = 599;
    if (!app) {
      if (sizeScreen) {
        widthScreen = sizeScreen && sizeScreen.width ? sizeScreen.width : 1366;
        heightScreen =
          sizeScreen && sizeScreen.height ? sizeScreen.height : 599;
      } else {
        widthScreen = size && size.width ? size.width : 1366;
        heightScreen = size && size.height ? size.height : 599;
      }
    } else {
      widthScreen = deviceWidth ? deviceWidth : 1366;
      heightScreen = deviceHeight ? deviceWidth : 599;
    }
    const ZoomX = widthScreen / Math.abs(bounds.maxX - bounds.minX);
    const ZoomY = heightScreen / Math.abs(bounds.maxY - bounds.minY);
    // // console.log(isMobile);
    // // console.log(size, Math.abs(bounds.maxX - bounds.minX), ZoomY);
    // // console.log(updated);
    // // console.log(getMinMaxCoordinates(updated));
    // // console.log(bounds);
    // console.log(ZoomX, ZoomY);
    setZoom(Math.min(ZoomX, ZoomY));

    setCanvasOffset({
      x: bounds.minX >= 0 ? -Math.abs(bounds.minX) : Math.abs(bounds.minX),
      y: bounds.minY >= 0 ? -bounds.minY : Math.abs(bounds.minY),
    });
  };

  const getSeatingData = async () => {
    setSaveLoad(true);
    try {
      // Step 1: retrieve data
      const response = await getSeatingMapData(seatingMapID);
      const data = response.data.data;
      // console.log(data);
      
      setShowLegend(true);
      // Step 2: create arrays based on parentType and parentID
      const combined = createMatricesFromItems(data.seats);
      let newObjects = data.objects.concat(
        data.sections,
        data.tables,
        data.texts,
        data.areas
      );
      setTiersTypes(convertTiersBack(data.tiers));
      setHoldTypes(convertHoldsBack(data.holds));
      let updated = JSON.parse(JSON.stringify(newObjects));
      updated.forEach((obj, index) => {
        Object.values(combined).forEach((section) => {
          if (obj.id === section[0][0].parentID) {
            if (obj.type === "matrix") {
              const matrix = section;
              updated[index] = { ...obj, matrix };
            }
            if (obj.type === "table") {
              const items = sortItemsBySide(section[0]);
              updated[index] = { ...obj, items };
            }
          }
        });
      });
      // console.log(updated);
      setOrgID(data.orgID);
      setObjects(updated);
      adjustZoomOffset(updated);
      setSaveLoad(false);
      return response.data.data;
    } catch {
      setSaveLoad(false);
    }
  };
  useEffect(() => {
    getSeatingData();
  }, []);
  useEffect(() => {
    adjustZoomOffset(objects);
  }, [sizeScreen]);
  //start canvas
  const canvasRef = useRef(null);

  const [tierError, setTierError] = useState(false);
  const [soldError, setSoldError] = useState(false);
  const [maxPerOrder, setMaxPerOrder] = useState(false);

  //user utils
  const [selectedCircles, setSelectedCircles] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedTableCircles, setSelectedTableCircles] = useState([]);

  const [currentEvent, setCurrentEvent] = useState();
  const [currentMouseX, setCurrentMouseX] = useState();
  const [currentMouseY, setCurrentMouseY] = useState();
  const [AccessCode, setAccessCode] = useState("");
  const [AccessCodeError, setAccessCodeError] = useState("");
  const [openAccessCode, setOpenAccessCode] = useState(false);
  const [currentHold, setCurrentHold] = useState([]);
  const [currentHolds, setCurrentHolds] = useState([]);
  //canvas tools
  const [canvasOffset, setCanvasOffset] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [initialPinchDistance, setInitialPinchDistance] = useState(null);
  const [lastTouchZoom, setLastTouchZoom] = useState(1);
  const [startDragPoint, setStartDragPoint] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [successAccess, setSuccessAccess] = useState(false);
  // drawing tools
  const circlePadding = 5; // Padding between circles
  const edgePadding = 3; // Smaller padding between circles and the rectangle
  const circleRadius = 10; // Circle radius
  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas?.getContext("2d");
    if (canvas && context) {
      // // console.log({zoom});

      drawGraphBackground(context, canvasOffset, zoom);
      // console.log("drawObjects", objects);
      
      drawObjects(
        context,
        objects,
        canvasOffset,
        zoom,
        circleRadius,
        circlePadding,
        edgePadding,
        selectedCircles,
        selectedTableCircles,
        selectedArea,
        HoldTypes,
        seatingTickets,
        eventID
      );
    }
  }, [
    objects,
    canvasOffset,
    zoom,
    selectedCircles,
    selectedTableCircles,
    selectedArea,
  ]);

  const getHoldFromSelect = (Hold) => {
    return Hold;
  };
  const handleCheckSubmit = (e) => {
    e.preventDefault();
    setAccessCodeError("");
    // console.log(currentHold, AccessCode);
    if (currentHold[0].accessCode.toLowerCase() === AccessCode.toLowerCase()) {
      setCurrentHolds((current) => {
        handleSelection(
          objects,
          currentEvent,
          currentMouseX,
          currentMouseY,
          selectedCircles,
          selectedTableCircles,
          setSelectedCircles,
          setSelectedTableCircles,
          circleRadius,
          circlePadding,
          edgePadding,
          selectedArea,
          setSelectedArea,
          HoldTypes,
          setOpenAccessCode,
          setCurrentHold,
          true,
          setSuccessAccess,
          setAccessCode,
          [...current, currentHold[0]],
          setTierError,
          setSoldError,
          seatingTickets
        );

        return [...current, currentHold[0]];
      });

      setStartDragPoint(null);
      setIsDragging(false);
      setOpenAccessCode(false);
    } else {
      setAccessCodeError("Wrong Password");
    }
  };

  const [isPinchZooming, setIsPinchZooming] = useState(false);

  const handleMouseDown = (event) => {
    event.preventDefault();

    const clientX =
      "touches" in event ? event.touches[0].clientX : event.clientX;
    const clientY =
      "touches" in event ? event.touches[0].clientY : event.clientY;
    const rect = canvasRef.current?.getBoundingClientRect();
    const startX = (clientX - (rect?.left ?? 0)) / zoom - canvasOffset.x;
    const startY = (clientY - (rect?.top ?? 0)) / zoom - canvasOffset.y;

    if ("touches" in event && event.touches.length === 2) {
      // Pinch zoom gesture detected
      const touch1 = event.touches[0];
      const touch2 = event.touches[1];
      const distance = Math.hypot(
        touch2.clientX - touch1.clientX,
        touch2.clientY - touch1.clientY
      );
      setInitialPinchDistance(distance);
      setLastTouchZoom(zoom);
      setIsPinchZooming(true);
      setIsDragging(true);
    } else {
      // Single touch or mouse interaction
      setIsDragging(true);
      setStartDragPoint({ x: clientX, y: clientY });
    }
  };

  const handleMouseMove = (event) => {
    if ("touches" in event && event.touches.length === 2) {
      const touch1 = event.touches[0];
      const touch2 = event.touches[1];
      const distance = Math.hypot(
        touch2.clientX - touch1.clientX,
        touch2.clientY - touch1.clientY
      );

      const pinchZoom = lastTouchZoom * (distance / initialPinchDistance);

      const rect = canvasRef.current?.getBoundingClientRect();
      const centerX = (touch1.clientX + touch2.clientX) / 2 - (rect?.left ?? 0);
      const centerY = (touch1.clientY + touch2.clientY) / 2 - (rect?.top ?? 0);

      const newZoom = Math.max(pinchZoom, 0.04); // Prevent zooming out too much, min 4%

      // Calculate the new offset to ensure the zoom happens towards the center point
      const newOffsetX = centerX / newZoom - centerX / zoom + canvasOffset.x;
      const newOffsetY = centerY / newZoom - centerY / zoom + canvasOffset.y;

      setZoom(newZoom);
      setCanvasOffset({ x: newOffsetX, y: newOffsetY });
      const clientXT = event.touches[0].clientX;
      const clientYT = event.touches[0].clientY;

      const dx = (clientXT - (startDragPoint?.x ?? 0)) / zoom;
      const dy = (clientYT - (startDragPoint?.y ?? 0)) / zoom;

      setCanvasOffset((prevOffset) => ({
        x: prevOffset.x + dx,
        y: prevOffset.y + dy,
      }));
      setStartDragPoint({ x: clientXT, y: clientYT });
      return;
    }

    if (!isDragging || isPinchZooming) return;

    const clientX =
      "touches" in event ? event.touches[0].clientX : event.clientX;
    const clientY =
      "touches" in event ? event.touches[0].clientY : event.clientY;

    const dx = (clientX - (startDragPoint?.x ?? 0)) / zoom;
    const dy = (clientY - (startDragPoint?.y ?? 0)) / zoom;

    setCanvasOffset((prevOffset) => ({
      x: prevOffset.x + dx,
      y: prevOffset.y + dy,
    }));
    setStartDragPoint({ x: clientX, y: clientY });
  };
  const handleMouseUp = (event) => {
    event.preventDefault();
    setIsDragging(false);

    if (isPinchZooming) {
      setIsPinchZooming(false);
      return;
    }

    const clientX =
      "touches" in event ? event.changedTouches[0].clientX : event.clientX;
    const clientY =
      "touches" in event ? event.changedTouches[0].clientY : event.clientY;
    const rect = canvasRef.current?.getBoundingClientRect();
    const mouseX = (clientX - (rect?.left ?? 0)) / zoom - canvasOffset.x;
    const mouseY = (clientY - (rect?.top ?? 0)) / zoom - canvasOffset.y;

    handleSelection(
      objects,
      event,
      mouseX,
      mouseY,
      selectedCircles,
      selectedTableCircles,
      setSelectedCircles,
      setSelectedTableCircles,
      circleRadius,
      circlePadding,
      edgePadding,
      selectedArea,
      setSelectedArea,
      HoldTypes,
      setOpenAccessCode,
      setCurrentHold,
      successAccess,
      setSuccessAccess,
      setAccessCode,
      currentHolds,
      setTierError,
      setSoldError,
      seatingTickets
    );
  };

  const handleCloseTierError = () => {
    setTierError(false);
  };
  const handleCloseSoldError = () => {
    setSoldError(false);
  };
  const handleCloseTierErrorTimer = () => {
    setTimeout(() => setTierError(false), 5000);
  };
  const handleCloseSoldErrorTimer = () => {
    setTimeout(() => setSoldError(false), 5000);
  };
  const handleCloseMaxError = () => {
    setMaxPerOrder(false);
  };
  const handleCloseMaxErrorTimer = () => {
    setTimeout(() => setMaxPerOrder(false), 5000);
  };
  useEffect(() => {
    handleCloseTierErrorTimer();
  }, [tierError]);
  useEffect(() => {
    handleCloseSoldErrorTimer();
  }, [soldError]);
  useEffect(() => {
    handleCloseMaxErrorTimer();
  }, [maxPerOrder]);

  const handleWheel = (event) => {
    const zoomIncrement = 0.01; // Adjust the zoom speed
    const newZoom =
      event.deltaY < 0 ? zoom + zoomIncrement : zoom - zoomIncrement;
    setZoom(Math.max(newZoom, 0.02)); // Prevent zooming out too much, min 10%
  };
  const findTicket = (tierID) => {
    return seatingTickets.find((tier) => tier.tierID === tierID);
  };

  const handleCloseAccess = () => {
    setStartDragPoint(null);
    setIsDragging(false);
    setOpenAccessCode(!openAccessCode);
  };

  const handleTouchEnd = (event) => {
    if (event.touches.length === 0) {
      setIsPinchZooming(false);
      setIsDragging(false);
    }
  };
  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      canvas.addEventListener("touchend", handleTouchEnd);
    }
    return () => {
      if (canvas) {
        canvas.removeEventListener("touchend", handleTouchEnd);
      }
    };
  }, []);

  // console.log(whish, app);

  return (
    <div className={styles.seating}>
      {saveLoad && <div className={styles.overlayLoad}></div>}

      {saveLoad && (
        <div className={styles.textLoad}>
          Loading
          <br />
          <span className={styles.loader}></span>
        </div>
      )}

      {openAccessCode && (
        <>
          <div className={styles.accessOverlay}></div>

          <div className={styles.accessDialog}>
            <div className={styles.header}>
              <h3>Seat Locked</h3>
              <div className={styles.closeAccess} onClick={handleCloseAccess}>
                x
              </div>
            </div>
            <div className={styles.body}>
              Access Code:{" "}
              <input
                type="text"
                onChange={(e) => setAccessCode(e.target.value)}
              />
            </div>
            <div style={{ color: "red" }}>{AccessCodeError}</div>
            <div className={styles.submit}>
              <button onClick={(e) => handleCheckSubmit(e)}>Submit</button>
            </div>
          </div>
        </>
      )}

      {true&& (
        <div className={styles.closeBtn} onClick={handleOpenCloseSeating}>
          <span>x</span>
        </div>
      )}
      <div className={styles.zooming}>
        <div onClick={() => setShowLegend(!showLegend)}>
          <BsExclamationCircle />
        </div>
        <hr />
        <div
          onClick={() =>
            setZoom((prev) => {
              return prev + 0.1;
            })
          }
        >
          +
        </div>
        <div
          onClick={() =>
            setZoom((prev) => {
              return prev - 0.1;
            })
          }
        >
          -
        </div>
      </div>

      {showLegend && (
        <div className={styles.legend}>
          <div className={styles.legendRow}>
            <div>
              <span style={{ backgroundColor: `black` }}></span> Unavailable
            </div>
            <div>--</div>
          </div>
          {TiersTypes.map((tier, index) => {
            if(eventID === "Kw09ngSW2Yq2ptUCoWg2" && (tier.TierID === "f05c1b18-ea86-4095-a174-86112d94be58" || tier.TierID === "5d0e1597-8030-426d-a2b4-7acff7869755")) return <></>
            return (
              <>
                {<hr />}
                <div className={styles.legendRow}>
                  <div>
                    <span
                      style={{ backgroundColor: `${tier.TierColor}` }}
                    ></span>{" "}
                    {tier.TierName}
                  </div>
                  <div>
                    {findTicket(tier.TierID)?.sales[0]?.customerPrice}{" "}
                    {findTicket(tier.TierID)?.currency}
                  </div>
                </div>
              </>
            );
          })}
        </div>
      )}
      <canvas
        ref={canvasRef}
        onMouseDown={handleMouseDown}
        onTouchStart={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onWheel={handleWheel}
        onTouchMove={handleMouseMove}
        className={styles.canvas}
        width={1450}
        height={768}
      />

      <SeatingCart
        selectedCircles={selectedCircles}
        selectedTableCircles={selectedTableCircles}
        seatingTickets={seatingTickets}
        TiersTypes={TiersTypes}
        HoldTypes={HoldTypes}
        selectedArea={selectedArea}
        setSelectedArea={setSelectedArea}
        setSelectedCircles={setSelectedCircles}
        setSelectedTableCircles={setSelectedTableCircles}
        utm_source={utm_source}
        eventID={eventID}
        seatingMapID={seatingMapID}
        user={user}
        app={app}
        maxPerOrder={maxPerOrder}
        setMaxPerOrder={setMaxPerOrder}
        whish={whish}
        redirectUrl={redirectUrl}
        userIdentifier={userIdentifier}
        objects={objects}
        orgID={orgID}
        event={event}
        handleOpenPolicy={handleOpenPolicy}
      />

      {tierError && (
        <MessageDisplay
          close={handleCloseTierError}
          message={"You can select items only from the same price class"}
        />
      )}
      {soldError && (
        <MessageDisplay
          close={handleCloseSoldError}
          message={"This seat is not available."}
        />
      )}
      {maxPerOrder && (
        <MessageDisplay
          close={handleCloseMaxError}
          message={"Exceeded maximum per order limit."}
        />
      )}
    </div>
  );
}
